import { IDs } from '../../../../../helpers/IDs';
import parse from 'html-react-parser';
import * as React from 'react';
import { renderText } from '../../assistent_helpers';
import style from '../../Assistent.less';
import styleBtn from '../../../../../core/elements/buttons.less';
import { WArchivIcon } from '../../../../../core/elements/WArchivIcon';

interface HinweiseElementProps extends React.ClassAttributes<any> {
    data: any;
}

export class HinweiseElement extends React.Component<HinweiseElementProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div
                className={style.customFormInfotext}
                style={{ padding: '0px 20px 20px' }}
            >
                {this.renderText()}
            </div>
        );
    }

    renderChecklisteDrucken(data: string): JSX.Element {
        const id: number = ((this.props.data[IDs.ENT_DATEIEN] || [])
            .find((item: any) => (item.kennung || null) === 'assistent_checkliste') || {}).datei || null;

        return (
            <div>
                <span style={{ float: 'right' }}>
                    <div style={{ display: 'inline-block', margin: '0 0 0 auto' }}>
                        <WArchivIcon
                            module={IDs.MOD_ETOOL_ADMIN}
                            archivId={id}
                            hideIcon
                            hideFilename
                            title={
                                <button className={styleBtn.actionButton} style={{ width: 'auto', marginRight: 5, marginLeft: 40 }}>
                                    Checkliste drucken
                                </button>
                            }
                        />
                    </div>
                </span>
                <p style={{ hyphens: 'auto' }}>{data}</p>
            </div>
        );
    }

    renderText(): JSX.Element | JSX.Element[] {
        const html: string = renderText('Geführter Modus - Hinweis Dateneingabe', this.props.data, true) || '';
        let pos: number = 0;

        if (!html) {
            return null;
        }
        return parse(html, {
            replace: domNode => {
                if (
                    pos === 0 && domNode.name && domNode.name === 'p' && !domNode.parent && !domNode.prev
                    && domNode.children
                ) {
                    const data: string = (domNode.children.find((node: any) => node.type === 'text') || {}).data || '';

                    if (data.length) {
                        return this.renderChecklisteDrucken(data);
                    }
                }
                ++pos;
            }
        });
    }
}
